// HTTP-инстанс для v3 API.
// Аналог `client_app/configs/apiConfig` — единая точка, которая знает companyId
// и подкладывает `mobile-token`. Все store-сервисы newgen ходят через неё.

import defaults from 'superagent-defaults';

const csrfToken = () => {
  const m = document.querySelector("meta[name='csrf-token']");
  return m ? m.getAttribute('content') : '';
};

const readBodyData = () => {
  const body = document.body;
  return {
    companyId: body.getAttribute('data-company-id'),
    mobileToken: body.getAttribute('data-mobile-token'),
  };
};

const state = {
  companyId: null,
  mobileToken: null,
};

const bootstrapped = () => {
  if (state.companyId === null) {
    const data = readBodyData();
    state.companyId = data.companyId;
    state.mobileToken = data.mobileToken || null;
  }
};

export const apiState = {
  setMobileToken(token) {
    state.mobileToken = token || null;
  },
  getMobileToken() {
    bootstrapped();
    return state.mobileToken;
  },
  getCompanyId() {
    bootstrapped();
    return state.companyId;
  },
};

const baseUrl = (path) => {
  bootstrapped();
  const p = path.replace(/^\/+/, '');
  return `/api/${state.companyId}/${p}`;
};

const buildRequest = (method, path) => {
  const agent = defaults();
  agent.set('X-CSRF-Token', csrfToken());
  agent.set('Accept', 'application/json');
  const token = state.mobileToken;
  if (token) agent.set('mobile-token', token);
  return agent[method](baseUrl(path));
};

const wrap = (req) => req.then(
  (res) => res.body,
  (err) => {
    const body = (err && err.response && err.response.body) || {};
    const error = new Error(body.error || body.message || err.message || 'request failed');
    error.status = (err && err.status) || 0;
    error.body = body;
    throw error;
  },
);

// Минимальный API, повторяющий axios-сигнатуры, которые ждут store-сервисы.
export const api = {
  get(path, params) {
    const req = buildRequest('get', path);
    if (params) req.query(params);
    return wrap(req);
  },
  post(path, payload) {
    const req = buildRequest('post', path);
    if (payload !== undefined) req.send(payload);
    return wrap(req);
  },
  put(path, payload) {
    const req = buildRequest('put', path);
    if (payload !== undefined) req.send(payload);
    return wrap(req);
  },
  del(path) {
    return wrap(buildRequest('del', path));
  },
  // multipart (для аватарки)
  postForm(path, formData) {
    bootstrapped();
    const req = defaults().post(baseUrl(path));
    req.set('X-CSRF-Token', csrfToken());
    req.set('Accept', 'application/json');
    if (state.mobileToken) req.set('mobile-token', state.mobileToken);
    // superagent сам выставит multipart boundary, если передать FormData
    req.send(formData);
    return wrap(req);
  },
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/api/instance.js